<template>
  <section :style="`background-image: url(${require('../assets/images/img2.jpg')});`" class="pb_section bg-light pb_slant-white" id="section-pricing">
    <div class="container">
      <div class="row justify-content-center mb-5">
        <div class="col-md-6 text-center mb-5">
          <h2>Цены и акции</h2>
        </div>
      </div>
      <div class="row" style="background: rgba(0,0,0,0.5);">
        <div class="col-md d-flex align-items-center">
          <div class="pb_pricing_v1 p-5 text-center text-white">
            <p class="pb_font-15">Скидка 10% при отметке в Инстаграмм</p>
            <p class="mb-0"><a href="#" role="button" class="btn btn-secondary">Заказать</a></p>
          </div>
        </div>
        <div class="col-md d-flex align-items-center justify-content-center">
          <div class="pb_pricing_v1 p-5 text-center text-white">
            <span class="price">150<sup>&#8381;</sup><span>/час</span></span>
            <p class="pb_font-15">с 10:00 до 15:00</p>
            <span class="price">200<sup>&#8381;</sup><span>/час</span></span>
            <p class="pb_font-15">с 15:00 до 22:00</p>
            <p class="mb-0"><a href="#" role="button" class="btn btn-ok text-white btn-shadow-blue">Заказать</a></p>
          </div>
        </div>
        <div class="col-md d-flex align-items-center">
          <div class="pb_pricing_v1 p-5 text-center text-white">
            <p class="pb_font-15">При оплате 3-х часов 4-ый час в подарок</p>
            <p class="mb-0"><a href="#" role="button" class="btn btn-secondary">Заказать</a></p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Pricing"
}
</script>

<style lang="scss" scoped>
.pb_section {
  background-size: cover;
  background-position: center;

  h2 {
    color: #FFFFFF;
  }
}
</style>
